import { createContext } from 'react';

export const EXPANDED_LOCALSTORAGE_KEY = 'expanded';

export const SidebarContext = createContext<{
    isExpanded: boolean;
}>({
    isExpanded: false
});
